var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.47998 12C2.47998 11.4696 2.69069 10.9609 3.06577 10.5858C3.44084 10.2107 3.94955 10 4.47998 10C5.01041 10 5.51912 10.2107 5.89419 10.5858C6.26927 10.9609 6.47998 11.4696 6.47998 12C6.47998 12.5304 6.26927 13.0391 5.89419 13.4142C5.51912 13.7893 5.01041 14 4.47998 14C3.94955 14 3.44084 13.7893 3.06577 13.4142C2.69069 13.0391 2.47998 12.5304 2.47998 12Z",
    fill: "#9EA3AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.48 12C10.48 11.4696 10.6907 10.9609 11.0658 10.5858C11.4408 10.2107 11.9495 10 12.48 10C13.0104 10 13.5191 10.2107 13.8942 10.5858C14.2693 10.9609 14.48 11.4696 14.48 12C14.48 12.5304 14.2693 13.0391 13.8942 13.4142C13.5191 13.7893 13.0104 14 12.48 14C11.9495 14 11.4408 13.7893 11.0658 13.4142C10.6907 13.0391 10.48 12.5304 10.48 12Z",
    fill: "#9EA3AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.48 12C18.48 11.4696 18.6907 10.9609 19.0658 10.5858C19.4408 10.2107 19.9495 10 20.48 10C21.0104 10 21.5191 10.2107 21.8942 10.5858C22.2693 10.9609 22.48 11.4696 22.48 12C22.48 12.5304 22.2693 13.0391 21.8942 13.4142C21.5191 13.7893 21.0104 14 20.48 14C19.9495 14 19.4408 13.7893 19.0658 13.4142C18.6907 13.0391 18.48 12.5304 18.48 12Z",
    fill: "#9EA3AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/Icon (6).c197d873d5d10ff414fa01085413c471.svg";
export { ForwardRef as ReactComponent };